import { useContext } from 'react'
import PropTypes from 'prop-types'

import { Box, Spacer, Typography } from '@telus-uds/components-web'

import { components } from '@digital-commerce/shared-utils'

import { getRecurringHeading, transformCancellationFeeContent } from './utils'
import { SuperScript } from './styles'
import useTranslate from '../../../hooks/useTranslate'
import localeContext from '../../../contexts/Locale'

const PaymentBreakdownHeader = ({ isAuthenticated, category, dataTestId }) => {
  const { WithLegal } = components
  const translate = useTranslate()
  const { lang } = useContext(localeContext)
  const translations = translate('priceSummary.paymentBreakdownWithMH', true)

  const termAndCondition = (
    <WithLegal
      content={
        isAuthenticated
          ? translations.firstBillFootnoteSlugForAuthUser
          : translations.firstBillFootnoteSlug
      }
      onReceiveContent={transformCancellationFeeContent({}, lang)}
      copy={lang}
    />
  )

  return (
    <Box direction="column" bottom={2}>
      <Typography
        variant={{ size: 'h3', colour: 'dark', bold: false }}
        testID={`${dataTestId}-price-summary-bill-${category}`}
      >
        {getRecurringHeading(category, translations)}
      </Typography>
      <Spacer space={2} />
      <Typography
        variant={{ size: 'small' }}
        testID={`${dataTestId}-price-summary-bill-comment-${category}`}
      >
        {translations.applicableTaxes}
        <SuperScript role="superscript">{termAndCondition}</SuperScript>
      </Typography>
    </Box>
  )
}

PaymentBreakdownHeader.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  category: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired
}

export default PaymentBreakdownHeader
